import * as React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

// cora web components
import withRouter from "../../coraWebComponents/utils/withRouter";
import Button from "../../coraWebComponents/buttons/Button";
import DropDownList from "../../coraWebComponents/forms/DropDownList";
import MaskedTextBox from "../../coraWebComponents/forms/MaskedTextBox";
import Input from "../../coraWebComponents/forms/Input";
import Tooltip from "../../coraWebComponents/forms/Tooltip";
import DateInput from "../../coraWebComponents/forms/DateInput";
import LoadingPanel from "../../coraWebComponents/LoadingPanel";

// prop types
import typyPracePropTypes from "../../propTypes/typyPracePropTypes";

// actions
import * as zpCTypPraceActions from "../../actions/ciselniky/zpCTypPraceActions";
import * as mapaActions from "../../actions/mapaActions";
import * as ziadostActions from "../../actions/ziadostActions";

import _ from "lodash";

class DetailStavby extends React.Component {
  constructor(props) {
    super(props);

    const detailStavby = props.ziadost.DetailStavby;

    this.state = {
      NAZOV_PROJEKTU: detailStavby ? detailStavby.NAZOV_PROJEKTU : "",

      AdresaStavby: detailStavby ? detailStavby.AdresaStavby : {
        ULICA: "",
        CS: null,
        CO: "",
        PSC: "",
        OBEC: "",
      },

      D_POZADOVANE_VYBAVENIE: detailStavby ? detailStavby.D_POZADOVANE_VYBAVENIE : null,
      D_ZAC_STAVBY: detailStavby ? detailStavby.D_ZAC_STAVBY : null,
      D_UKONC_STAVBY: detailStavby ? detailStavby.D_UKONC_STAVBY : null,
      CIS_ZIAD_ISV: detailStavby ? detailStavby.CIS_ZIAD_ISV : null,
      ID_STAV_ISV: detailStavby ? detailStavby.ID_STAV_ISV : null,


      STAVENISKO_NAZOV: detailStavby ? detailStavby.STAVENISKO_NAZOV : "",
      STAVENISKO_VEDUCI: detailStavby ? detailStavby.STAVENISKO_VEDUCI : "",
      STAVENISKO_KONTAKT: detailStavby ? detailStavby.STAVENISKO_KONTAKT : "",

      titles: {
        NAZOV_PROJEKTU: "Názov projektu / Názov stavby",
        ULICA: "Ulica",
        CS: "Číslo súpisné",
        CO: "Číslo orientačné",
        PSC: "Poštové smerodajné číslo",
        OBEC: "Obec",
        STAVENISKO_NAZOV: "Názov spoločnosti",
        STAVENISKO_VEDUCI: "Vedúci",
        STAVENISKO_KONTAKT: "Telefón",
      },
    };
  }

  saveData = async () => {
    const {
      typPrace,
      getURL,
      ulozData,
      getLatLngFromGoogleMap,
      getURLBasedOnLatLng,
      ziadost,
    } = this.props;

    const { AdresaStavby } = this.state;

    const detailStavby = {
      ...this.state,
      ...typPrace
    };

    const AdresaStavbyOld = ziadost?.DetailStavby?.AdresaStavby || null;
    if (AdresaStavbyOld === null || !_.isEqual(AdresaStavby, AdresaStavbyOld)) {
      await getURL(AdresaStavby);
      if (this.props.url === "") {
        await getLatLngFromGoogleMap(AdresaStavby);

        const { lat, lng } = this.props;
        await getURLBasedOnLatLng({ lat, lng });
      }
    }

    ulozData({ DetailStavby: detailStavby });
  };
  handleOnChange = (name, value) => {
    this.setState((state) => ({ ...state, [name]: value }));
  };
  handleOnChangeAdresaStavby = (name, value) => {
    this.setState((state) => ({
      AdresaStavby: { ...state.AdresaStavby, [name]: name === "CS" ? parseInt(value) : value },
    }));
  };
  handleOnChangeTypPrace = async (name, data) => {
    await this.props.changeTypPrace(data);
  };

  componentDidMount = async () => {
    const { typyPrace, getTypyPrace, setRef } = this.props;
    if (typyPrace.length === 0) await getTypyPrace();

    setRef(this);
  };

  render() {
    const { AdresaStavby, titles } = this.state;

    const {
      typyPrace,
      typPrace,
      isLoading,
      cancel,
      moveBack,
      moveNext,
      onKeyDown,
      className,
      index,
    } = this.props;

    const media = window.matchMedia('only screen and (min-width: 768px)');

    return (
      <div className={`row m-0 ${className}`}>
        <div className={media.matches ? "col-6 offset-3 p-0 forWeb" : "col p-0 forMobile"}>
          <div className="card formular">
            <div className="form-body">
              <Tooltip>
                {/* FORM */}
                <form
                  id={media.matches ? `webForm${index}` : `webMobile${index}`}
                  className="k-form"
                  onSubmit={moveNext}
                  onKeyDown={onKeyDown}
                >
                  {/* TITLE */}
                  <div className="card-title">
                    <div>Detail stavby</div>
                  </div>

                  <p>&nbsp;</p>
                  <div>Detail stavby</div>
                  {/* TYP PRACE */}
                  <div className="k-form-field">
                    <span>{"*Typ práce"}</span>
                    <DropDownList
                      className="basicwhiteBackground"
                      name="typPrace"
                      textField="N_TYP_PRACE"
                      data={typyPrace}
                      onChange={this.handleOnChangeTypPrace}
                      value={typPrace}
                      notSetValue={!typPrace}
                      required
                    />
                  </div>
                  {/* NAZOV PROJEKTU */}
                  <div className="k-form-field">
                    <span>{"*Názov projektu / Názov stavby"}</span>
                    <Input
                      title={titles.NAZOV_PROJEKTU}
                      type="text"
                      name="NAZOV_PROJEKTU"
                      onChange={this.handleOnChange}
                      value={this.state.NAZOV_PROJEKTU}
                      required
                    />
                  </div>

                  <p>&nbsp;</p>
                  <div>Adresa stavby</div>
                  {/* ULICA */}
                  <div className="k-form-field">
                    <span>{"Ulica"}</span>
                    <Input
                      title={titles.ULICA}
                      type="text"
                      name="ULICA"
                      onChange={this.handleOnChangeAdresaStavby}
                      value={AdresaStavby.ULICA}
                    />
                  </div>
                  {/* CS/CO */}
                  <div
                    className="k-form-field flexGroup"
                    style={{ marginTop: "0px" }}
                  >
                    <div
                      className="k-form-field flex1"
                      style={{ padding: "0px 5px 0px 0px" }}
                    >
                      <span>{"*ČS"}</span>
                      <Input
                        title={titles.CS}
                        type="number"
                        name="CS"
                        onChange={this.handleOnChangeAdresaStavby}
                        value={AdresaStavby.CS}
                        required
                      />
                    </div>

                    <div
                      className="k-form-field flex1"
                      style={{
                        padding: "0px 0px 0px 5px",
                      }}
                    >
                      <span>{"ČO"}</span>
                      <Input
                        title={titles.CO}
                        type="text"
                        name="CO"
                        onChange={this.handleOnChangeAdresaStavby}
                        value={AdresaStavby.CO}
                      />
                    </div>
                  </div>
                  {/* PSC/OBEC*/}
                  <div
                    className="k-form-field flexGroup"
                    style={{ marginTop: "0px" }}
                  >
                    <div
                      className="k-form-field flex1"
                      style={{ padding: "0px 5px 0px 0px" }}
                    >
                      <span>{"*PSČ:"}</span>
                      <MaskedTextBox
                        title={titles.PSC}
                        name="PSC"
                        value={AdresaStavby.PSC}
                        onChange={this.handleOnChangeAdresaStavby}
                        mask="000 00"
                        required
                      />
                    </div>
                    <div
                      className="k-form-field flex2"
                      style={{
                        padding: "0px 0px 0px 5px",
                      }}
                    >
                      <span>{"*Obec:"}</span>
                      <Input
                        title={titles.OBEC}
                        type="text"
                        name="OBEC"
                        value={AdresaStavby.OBEC}
                        onChange={this.handleOnChangeAdresaStavby}
                        required
                      />
                    </div>
                  </div>

                  <p>&nbsp;</p>
                  <div>Dôležité dáta</div>
                  {/* DATUM VYBAVENIA */}
                  <div hidden className="k-form-field">
                    <span>{"Požadovaný dátum vybavenia"}</span>
                    <DateInput
                      name="D_POZADOVANE_VYBAVENIE"
                      onChange={this.handleOnChange}
                      value={this.state.D_POZADOVANE_VYBAVENIE}
                    />
                  </div>
                  {/* DATUM ZACIATOK STAVBY */}
                  <div hidden className="k-form-field">
                    <span>{"Očakávaný začiatok stavby"}</span>
                    <DateInput
                      name="D_ZAC_STAVBY"
                      onChange={this.handleOnChange}
                      value={this.state.D_ZAC_STAVBY}
                    />
                  </div>
                  {/* DATUM UKONCENIE STAVBY */}
                  <div hidden className="k-form-field">
                    <span>{"Očakávané ukončenie stavby"}</span>
                    <DateInput
                      name="D_UKONC_STAVBY"
                      onChange={this.handleOnChange}
                      value={this.state.D_UKONC_STAVBY}
                    />
                  </div>
                  {/* CISLO ZIADOSTI Z IS VYSTAVBY */}
                  <div className="k-form-field">
                    <span>{"Číslo žiadosti z IS výstavby"}</span>
                    <Input
                      type="text"
                      name="CIS_ZIAD_ISV"
                      maxLength={11}
                      onChange={this.handleOnChange}
                      value={this.state.CIS_ZIAD_ISV}
                    />
                  </div>
                  {/* ID STAVBY Z IS VYSTAVBY */}
                  <div className="k-form-field">
                    <span>{"ID stavby z IS výstavby"}</span>
                    <Input
                      type="text"
                      name="ID_STAV_ISV"
                      maxLength={6}
                      onChange={this.handleOnChange}
                      value={this.state.ID_STAV_ISV}
                    />
                  </div>

                  <p>&nbsp;</p>
                  <div>Stavenisko</div>
                  {/* NAZOV */}
                  <div className="k-form-field">
                    <span>{"Názov"}</span>
                    <Input
                      title={titles.STAVENISKO_NAZOV}
                      type="text"
                      name="STAVENISKO_NAZOV"
                      onChange={this.handleOnChange}
                      value={this.state.STAVENISKO_NAZOV}
                    />
                  </div>
                  {/* VEDUCI */}
                  <div className="k-form-field">
                    <span>{"Vedúci"}</span>
                    <Input
                      title={titles.STAVENISKO_VEDUCI}
                      type="text"
                      name="STAVENISKO_VEDUCI"
                      onChange={this.handleOnChange}
                      value={this.state.STAVENISKO_VEDUCI}
                    />
                  </div>
                  {/* KONTAKT */}
                  <div className="k-form-field">
                    <span>{"Telefón"}</span>
                    <Input
                      title={titles.STAVENISKO_KONTAKT}
                      type="tel"
                      placeholder="+421999999999"
                      pattern="([+]\d{3}\s\d{3}\s\d{3}\s\d{3}|[0]{2}\d{3}\s\d{3}\s\d{3}\s\d{3})|(^\d{4}\s\d{3}\s\d{3}$)|(^\d{10}$)|([+]\d{12}|[0]{2}\d{12})|([+]\d{2}\s\d{3}\s\d{3}\s\d{4}|[0]{2}\d{2}\s\d{3}\s\d{3}\s\d{4})|([+]\d{2}\s\d{2}\s\d{4}\s\d{4}|[0]{2}\d{2}\s\d{2}\s\d{4}\s\d{4})|([+]\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2}|[0]{2}\d{3}\s\d{2}.\d{3}\s\d{2}\s\d{2})|([0]\d{2}.\d{3}\s\d{2}\s\d{2})|([+]\d{3}\s\d{2}.\d{7}|[0]{2}\d{3}\s\d{2}.\d{7})|([0]\d{2}.\d{7}$)"
                      validationMessage="Nesprávny formát telefónneho čísla"
                      name="STAVENISKO_KONTAKT"
                      onChange={this.handleOnChange}
                      value={this.state.STAVENISKO_KONTAKT}
                    />
                  </div>
                  {/* BUTTONS */}
                  <div className="k-form-field flexGroup">
                    <Button label="Zrusiť" onClick={cancel} primary />
                    <div className="flexGroup">
                      <Button label="Späť" onClick={moveBack} primary />
                      <Button type="submit" label="Ďalej" primary={true} />
                    </div>
                  </div>
                </form>
              </Tooltip>
            </div>
          </div>
        </div>
        <LoadingPanel isLoading={isLoading} />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isLoading: state.zpCTypPrace.isLoading || state.mapa.isLoading,
  typPrace: state.zpCTypPrace.item,
  typyPrace: state.zpCTypPrace.list,
  url: state.mapa.url,
  lat: state.mapa.lat,
  lng: state.mapa.lng,
});

const mapDispatchToProps = (dispatch) => ({
  changeTypPrace: (data) => dispatch(zpCTypPraceActions.changeTypPrace(data)),
  ulozData: (data) => dispatch(ziadostActions.ulozData(data)),
  getURL: (data) => dispatch(mapaActions.getURL(data)),
  getURLBasedOnLatLng: (data) =>
    dispatch(mapaActions.getURLBasedOnLatLng(data)),
  getLatLngFromGoogleMap: (data) =>
    dispatch(mapaActions.getLatLngFromGoogleMap(data)),
  getTypyPrace: () => dispatch(zpCTypPraceActions.getZP_C_TYP_PRACE()),
});

DetailStavby.propTypes = {
  setRef: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func.isRequired,
  moveNext: PropTypes.func.isRequired,
  moveBack: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  ziadost: PropTypes.object,
  isLoading: PropTypes.bool,
  lat: PropTypes.number,
  lng: PropTypes.number,
  typPrace: typyPracePropTypes.typPrace,
  typyPrace: PropTypes.arrayOf(typyPracePropTypes.typPrace),
  changeTypPrace: PropTypes.func,
  getTypyPrace: PropTypes.func,
  className: PropTypes.string,
  getStepperState: PropTypes.func,
  getURL: PropTypes.func,
  getURLBasedOnLatLng: PropTypes.func,
  getLatLngFromGoogleMap: PropTypes.func,
  ulozData: PropTypes.func,
  url: PropTypes.string,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DetailStavby)
);
